import { Component, Vue, Prop } from 'vue-property-decorator';
import QuestionnaireService from '@/services/questionnaire.service';
import { QuestionnaireDTO } from '@/models/QuestionnaireDTO';
import QuestionnaireIdentity from '@/components/QuestionnaireIdentity/QuestionnaireIdentity.vue';
import ModalTemplate from '@/components/ModalTemplate/ModalTemplate.vue';
import UserService from '@/services/user.service';
import StepStatus from '@/components/StepStatus/StepStatus.vue';
import RenounceButton from '@/components/RenounceButton/RenounceButton.vue';

@Component({
  components: {
    QuestionnaireIdentity,
    ModalTemplate,
    StepStatus,
    RenounceButton,
  },
})
export default class QuestIdentity extends Vue {
  @Prop({ required: false, default: false }) public isRecap!: boolean;
  public partId: number | undefined;
  public questionnaire: QuestionnaireDTO = {} as QuestionnaireDTO;
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;
  public showModal: boolean = false;

  /**
   * Get an array of all the property names from the questionnaire data in lowercase
   */
  get instanceFields(): string[] {
    if (this.$store.state.questionnaire) {
      let fields: string[] = [];
      Object.keys(this.questionnaire).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }
  
  /**
   * Get the errors returned by the API corresponding to the questionnaire data properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      let errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  protected mounted() {
    this.partId = Number(this.$route.params.partId);
    // Get the consents from API or store
    if (Object.entries(this.$store.state.questionnaire).length === 0) {
      this.fetchQuestionnaire(this.partId);
    } else {
      this.questionnaire = this.$store.state.questionnaire;
    }
  }

  /**
   * Fetch the questionnaire data with the service
   * @param partId The participant ID
   */
  protected fetchQuestionnaire(partId: number) {
    QuestionnaireService.fetchQuestionnaire(partId, '')
      .then((response) => {
        this.questionnaire = response as QuestionnaireDTO;
      });
  }

  protected async onSubmit(event: any) {
    await QuestionnaireService.updateQuestionnaire(this.questionnaire, 'identity')
      .then(() => {
        this.questionnaire.isIdentityValidated = true;
        this.$store.commit('setQuestionnaire', this.questionnaire);
        if (event.submitter.id === 'btn-continue') {
          this.$router.push({
            name: 'consent',
            params: {
              screening: this.$route.params.screening,
              partId: String(this.partId),
            },
          });
        }
      });
  }

  protected hideModal() {
    this.showModal = false;
  }

  protected logout() {
    this.hideModal();
    UserService.clearData();
    // Empty all data relative to the previous dossier that was closed
    this.$store.commit('resetDossierState');
    this.$router.push({
      name: 'participant',
      params: {
        screening: this.$route.params.screening,
      },
    });
  }
}

